module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/back-54dba15a2b4212dfdc22a7f70ac08193.png";